import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const HERO_ANIMATION_STATES = {
  finance: 'finance',
  mileage: 'mileage',
  none: '',
  vrm: 'vrm',
} as const;

export type HeroAnimationState = typeof HERO_ANIMATION_STATES[keyof typeof HERO_ANIMATION_STATES];

export type PageTransitionState ={
  animate?: boolean;
  animateFooter?: boolean;
}

const usePageTransitionState = ():PageTransitionState => {
  const history = useHistory();
  return (history?.location?.state as PageTransitionState) ?? {};
};

const useStopAnimationFallback = (trigger: boolean, stopCallBack: () => void, delay = 1000) => {
  useEffect(() => {
    if (!trigger) {
      return;
    }
    const timer = setTimeout(() => stopCallBack(), delay);
    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timer);
  }, [trigger, stopCallBack, delay]);
};

export { HERO_ANIMATION_STATES, usePageTransitionState, useStopAnimationFallback };
